module.exports = __webpack_public_path__ + "img/register-2-login.7079efb7.png";